import React from 'react'

export function MaterialSymbolsFactCheckOutline(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M4 21q-.825 0-1.413-.588T2 19V5q0-.825.588-1.413T4 3h16q.825 0 1.413.588T22 5v14q0 .825-.588 1.413T20 21H4Zm0-2h16V5H4v14Zm1-2h5v-2H5v2Zm9.55-2l4.95-4.95l-1.425-1.425l-3.525 3.55l-1.425-1.425l-1.4 1.425L14.55 15ZM5 13h5v-2H5v2Zm0-4h5V7H5v2ZM4 19V5v14Z"
      ></path>
    </svg>
  )
}
export default MaterialSymbolsFactCheckOutline
